import { Dropdown } from "antd";
import type { MenuProps } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentLang = i18n.language?.startsWith("bg") ? "bg" : "en";

  const items: MenuProps["items"] = [
    {
      key: "bg",
      label: (
        <span className={currentLang === "bg" ? "font-bold" : ""}>
          🇧🇬 Български
        </span>
      ),
    },
    {
      key: "en",
      label: (
        <span className={currentLang === "en" ? "font-bold" : ""}>
          🇬🇧 English
        </span>
      ),
    },
  ];

  const onClick: MenuProps["onClick"] = ({ key }) => {
    i18n.changeLanguage(key);
  };

  return (
    <Dropdown
      menu={{ items, onClick, selectedKeys: [currentLang] }}
      trigger={["click"]}
      placement="bottomRight"
    >
      <div className="flex items-center gap-1 cursor-pointer px-2 py-1 rounded-md hover:bg-gray-100 transition-colors">
        <GlobalOutlined className="!text-gray-500 text-lg" />
        <span className="text-xs font-medium text-gray-600 uppercase">
          {currentLang}
        </span>
      </div>
    </Dropdown>
  );
}
